"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allStudentUser = void 0;
var enums_1 = require("../enums");
exports.allStudentUser = {
    guid: 'allStudentUsers',
    avatar: 'black',
    username: '',
    email: '',
    firstName: 'All Students',
    lastName: '',
    schoolGuid: '',
    role: enums_1.IdentityRolesEnum.SYSTEM,
    brand: enums_1.BrandEnum.MONARCH,
    lastLoginDate: '',
    active: true,
};
